import { FilterState } from "@/components/ProjectList/types";
import { create } from "zustand";
import { persist } from "zustand/middleware";

type KanbanFilterState = {
  filters: Record<string, FilterState | undefined>;
  setFilter: (projectId: string, filter: Partial<FilterState>) => void;
  getFilter: (projectId: string) => FilterState;
  clearFilter: (projectId: string) => void;
};

const getDefaultFilter = (): FilterState => ({
  userIds: [],
  labels: [],
  search: "",
  statuses: [],
  estimates: [],
  priorities: [],
  dueDates: {
    none: false,
    overdue: false,
    today: false,
    thisWeek: false,
    nextWeek: false,
    later: false,
  },
});

export const useKanbanFilterStore = create<KanbanFilterState>()(
  persist(
    (set, get) => {
      return {
        filters: {},
        setFilter: (projectId: string, filter: Partial<FilterState>) =>
          set((state) => ({
            filters: {
              ...state.filters,
              [projectId]: {
                ...getDefaultFilter(),
                ...state.filters[projectId],
                ...filter,
              },
            },
          })),
        getFilter: (projectId: string) => {
          const state = get();
          return state.filters[projectId] || getDefaultFilter();
        },
        clearFilter: (projectId: string) =>
          set((state) => {
            const newFilters = { ...state.filters };
            delete newFilters[projectId];
            return { filters: newFilters };
          }),
      };
    },
    {
      name: "kanban-filter",
      partialize: (state) => ({
        filters: state.filters,
      }),
    }
  )
);
